const init = () => {

    var $component = $('.js-search-page');
    if (!$component.length) return;

    var $body = $(document.body);
    var $filtersTarget = $component.find('.js-filters-target');
    var $filtersPanelTarget = $body.find('.c-filters-panel');
    var $searchTarget = $component.find('.js-search-target'); 
    var currentFieldVal = '';
    var currentPage = 0;

    var $noResults = $searchTarget.find('.c-search-results__none');

    // flag for filter re-rendering
    var updateFilters = true;
    
    // flag to bypass field value check and append results
    var isLoadingMore = false;

    // contains references to selected facet keys
    var selectedFacets;
    
    // facet filters parameter for search
    var facetFiltersParam = [];

    $filtersPanelTarget.on('click', '.js-close-filters', closeFilters);
    function closeFilters() {
        $body.removeClass('filters-open');
    }

    $filtersPanelTarget.on('click', '.js-clear-filters', clearFilters);
    function clearFilters() {
        
        // reset

        var $selected = $filtersTarget.find('.is-selected');
        var $panelSelected = $filtersPanelTarget.find('.is-selected'); 
        $selected.add($panelSelected).removeClass('is-selected');

        updateFilters = false;
        getSuggestions();
        $filtersTarget.removeClass('is-hiding-more-filters-btn');
        $body.removeClass('filters-open');
    }

    $component.on('paste keyup', '#primary-search', onFieldChange);
    var keys = {
        ESC: 27,
        TAB: 9,
        RETURN: 13,
        UP: 38,
        DOWN: 40
    };

    $filtersTarget.on('click', '.c-filters__show-more', function() {
        $body.toggleClass('filters-open');
    });

    // Handle page dimmer clicks directly
    function onPageDimmerClick(e) {
        if ($body.hasClass('filters-open')) {
            $body.removeClass('filters-open');
        }
    }
    
    // Listen for page dimmer clicks on document
    $(document).on('click', '.page-dimmer', onPageDimmerClick);

    $searchTarget.on('click', '.c-search-results__load-more', function() {
        currentPage ++;
        isLoadingMore = true;
        getSuggestions();
    })

    $filtersTarget.on('click', '.c-filter-list__btn', onFilterClick);
    $filtersPanelTarget.on('click', '.c-filter-list__btn', onFilterClick);
    
    function onFilterClick(e) {

        var $that = $(this);
        
        var $parentList = $that.closest('.c-filter-list');
        if ($that.hasClass('is-selected')) {
            $parentList.removeClass('has-selected-child');
            $that.removeClass('is-selected');
        } else {
            $parentList.find('.is-selected').removeClass('is-selected');
            $parentList.addClass('has-selected-child');
            $that.addClass('is-selected');
        }

        // type
        var $closest = $that.closest('.c-filters');
        if (!$closest.length) {
            // mobile
        } else {
            var classList = $closest[0].classList;
            if (classList.contains('c-filters--primary')) {
                // primary

                // show more filters visibility
                var isSelected = $that.hasClass('is-selected');
                var isBooksBtn = $that.attr('data-facet-key') === 'title';
                if (isSelected && !isBooksBtn) {
                    $filtersTarget.addClass('is-hiding-more-filters-btn');

                    // deselect secondary filters
                    $filtersPanelTarget.find('button.is-selected').removeClass('is-selected');
                    $filtersTarget.find('.c-filters--secondary button.is-selected').removeClass('is-selected');

                } else {
                    $filtersTarget.removeClass('is-hiding-more-filters-btn');
                }

            } else if (classList.contains('c-filters--secondary')) {
                // secondary
            }
        }

        updateFilters = false;
        currentPage = 0;

        getSuggestions();
    }

    function clearSelectedFacets() {
        selectedFacets = {
            type: '',
            genres: '',
            lists: ''
        }; 
    }

    $filtersPanelTarget.on('click', '.js-filter-trigger', toggleFilterCategory);

    // Initialize directly when component loads
    function init() {
        clearSelectedFacets();
        var query = window.app.state.urlParams.hasOwnProperty('q') ? window.app.state.urlParams.q : '';
        if (query !== '') {
            getSuggestions();
        }
    }

    // Call init immediately if app.state is ready, otherwise wait for it
    if (window.app && window.app.state && window.app.state.urlParams) {
        init();
    } else {
        // Wait for app.state to be ready
        const checkAppReady = setInterval(() => {
            if (window.app && window.app.state && window.app.state.urlParams) {
                clearInterval(checkAppReady);
                init();
            }
        }, 50);
    }

    function render(data) {

        if (!data.primary.filters.length) {
            $filtersTarget.empty();
            return;
        }

        var nodes = Handlebars.templates['filters'](data);
        $filtersTarget.empty();
        $filtersTarget.append(nodes);

        var panel = Handlebars.templates['filters-panel'](data);
        $filtersPanelTarget.empty();
        $filtersPanelTarget.append(panel);
        
    }

    function onFieldChange(e) {
        
        switch (e.which) {

            case keys.ESC:
                
            break;
            case keys.RETURN:
                // submit
            break;
            case keys.UP:
                
            break;
            case keys.DOWN:
                
            break;
            default:
                // all other key input
                updateFilters = true;
                currentPage = 0;
                getSuggestions();
                break;
        }
    }

    function getSuggestions() {
        
        var $field = $component.find('#primary-search');
        var fieldVal = $field.val();

        // value check - but allow filter changes even if field value is the same
        if (!isLoadingMore) {
            if (fieldVal === currentFieldVal && updateFilters) {
                return;       
            }
        }

        currentFieldVal = fieldVal;
        if (fieldVal === '') {
            $searchTarget.empty();
            $noResults.find('.c-search-results__none-title').text('Find something readworthy.');
            $searchTarget.append($noResults);
            $filtersTarget.empty();
            return;
        }

        var hitsPerPage = 24;
        if (window.app.state.breakpoint === 'tablet') hitsPerPage = 25;

        // Get facet filters from selected filter buttons
        var facetFilters = getFacetFilters();
        
        const searchParams = {
            query: fieldVal,
            page: currentPage,
            hitsPerPage: hitsPerPage,
            attributesToRetrieve: [
                'title',
                'thumbnail',
                'thumbnails',
                'link',
                'type',
                'author',
                'shortDescription',
                'subtitle',
                'initials',
                'ages',
                'genres'
            ],
            facets: [
                'ages',
                'genres',
                'lists',
                'type'
            ],
            filters: 'region:' + window.app.state.region.toUpperCase(),
            facetFilters: facetFilters
        };
        
        window.app.searchClient.search(searchParams, onResponse);
    }

    function getFacetFilters() {
        facetFiltersParam = [];
        var $selected = $filtersTarget.find('.is-selected');
        
        // mobile view hack. atm mobile filters and desktop filters are not kept in sync. add to onFilterClick()
        var $panelSelected = $filtersPanelTarget.find('.is-selected'); 
        $selected = $selected.add($panelSelected);

        
        $selected.each(function(i, el) {
            var $el = $(el);
            var facetKey = $el.attr('data-facet-key');
            var facetList = $el.attr('data-facet-list');
            selectedFacets[facetList] = facetKey;

            // https://www.algolia.com/doc/guides/managing-results/refine-results/filtering/in-depth/filters-and-facetfilters/
            var filterString = facetList + ':' + facetKey;
            facetFiltersParam.push(filterString);
        });

        return facetFiltersParam;
    }

    function onResponse(response) {

        window.app.SearchResults.render(response, '.js-search-target', isLoadingMore, onResponseRender);
        if (updateFilters) {
            getFilters(response);
            $body.removeClass('filters-open');
        }

        isLoadingMore = false;
    }

    function onResponseRender() {
        if (window.textClampRun) {
            window.textClampRun();
        }
    }

    function getFilters(response) {
        var filters = {
            primary: {
                filters: []
            },
            secondary: []
        };

        if (response.facets && response.facets.type) {
            filters.primary.filters = Object.entries(response.facets.type).map(([key, val]) => {
                var o = {
                    title: ((key === 'title') ? 'book' : key) + ((val > 1) ? 's' : ''),
                    total: val,
                    facetKey: key,
                    facetList: 'type'
                }
                if (o.title.indexOf('teachers-notes') > -1) {
                    o.title =  "teacher's notes"
                }
                if (selectedFacets.type === key) o.selected = true;
                return o;
            });
        }

        // facets.genres
        if (response.facets && response.facets.genres) {
            filters.secondary.push({
                title: 'Category',
                filters: Object.entries(response.facets.genres).map(([key, val]) => {
                    var o = {
                        title: key,
                        total: val,
                        facetKey: key,
                        facetList: 'genres'
                    }
                    if (selectedFacets.genres === key) o.selected = true;
                    return o;
                })
            });
        }
        
        render(filters);
    }

    // from nav.js
    function toggleFilterCategory(e) {

        if (window.app.state.breakpoint !== 'phone') return;

        e.preventDefault();

        var $that = $(this);
        if ($that.hasClass('is-open')) {
            $that.removeClass('is-open');
            var $links = $that.next();
            $links.css('height', 0);
        } else {

            // close all subcategories
            var $subTriggers = $filtersPanelTarget.find('.js-filter-trigger');
            $subTriggers.removeClass('is-open');
            $subTriggers.next().css('height', 0);

            // set height for css anim
            var $links = $that.next();
            $links.css('height', 'auto');
            var h = $links.height();
            $links.css('height', 0);
            $links.height(h);
            $that.addClass('is-open');

            // scroll to subcategory
            var $container = $that.parent();
            $container.animate({
                scrollTop: $that.position().top - 58
            });
        }
    }

}

export default init;